import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackId"];
import UIImage from 'UIComponents/image/UIImage';
import { useAchievementImages } from '../achievementImagesQueries';
import { jsx as _jsx } from "react/jsx-runtime";
export const CertificateImage = _ref => {
  let {
      trackId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    images: {
      certificateURL
    }
  } = useAchievementImages({
    trackId
  });
  return /*#__PURE__*/_jsx(UIImage, Object.assign({}, props, {
    crossOrigin: "anonymous",
    "data-category": "cert",
    height: 880,
    responsive: true,
    src: certificateURL,
    width: 1140
  }));
};